import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[550px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Diverse%20curated%20product%20collection%20flat%20lay%20with%20sneakers%20leather%20bags%20watches%20perfume%20bottles%20and%20accessories%20on%20light%20travertine%20surface%20artistic%20editorial%20photography%20with%20warm%20sunlight%20gentle%20shadows%20harmonious%20neutral%20composition&width=1600&height=900&seq=cta-full-v2&orientation=landscape"
        alt="Start exploring the best AllChinaBuy Spreadsheet today"
        title="AllChinaBuy Spreadsheet CTA"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 text-center px-6">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white font-bold uppercase tracking-wide mb-4">
          AllChinaBuy Sheet
        </h2>
        <p className="text-white/80 text-sm md:text-lg mb-8 max-w-xl mx-auto">
          Start exploring the best AllChinaBuy Spreadsheet today. Thousands of verified products waiting for you.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 bg-foreground-900 hover:bg-foreground-800 text-white px-10 py-4 rounded-full text-sm md:text-base font-bold whitespace-nowrap transition-all cursor-pointer"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center -ml-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-white text-sm"></i>
            </div>
          </span>
          AllChinaBuy Sheet
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-white text-lg"></i>
          </div>
        </a>
      </div>
    </section>
  );
}